import StatusBadge from "../../Customers/StatusBadge"; // Update the import path as needed
import { formatCellValue ,formatDateForDisplay} from "../../Utils/UtilityFunctions";
export const userColoumns = () => {
  const columns = [
    {
      accessorKey: 'userId',
      header: 'User ID',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'userName',
      header: 'User Name',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'fullName',
      header: 'Full Name',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'role',
      header: 'User Role',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'email',
      header: 'Email',
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'phone',
      header: 'Phone',
     Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'status',
      header: 'Status',
      Cell: ({ cell }) => {
        const value = cell.getValue();

        // Normalize the status value
        let normalizedStatus;
        switch (value?.toLowerCase()) {
          case 'active':
            normalizedStatus = 'Active';
            break;
          case 'inactive':
            normalizedStatus = 'Inactive';
            break;
          case 'unverified':
            normalizedStatus = 'Unverified';
            break;
          case 'unregistered':
            normalizedStatus = 'Unregistered';
            break;
          default:
            normalizedStatus = value || '-';
            break;
        }

        return <StatusBadge value={normalizedStatus} />;
      }
    },
  ];

  return columns;
};

export function extractedDataForUser(data) {
  return data.map(item => {
    const domainCharacteristic = item.role;
    let domainValue = '-';

    if (domainCharacteristic) {
      const value = domainCharacteristic;
      domainValue = !value ? "" :
        value === 'operatorOperationUser' ? 'EV Operations User' :
          value === 'operatorBusinessUser' ? 'EV Business User' :
            value === 'providerOperationUser' ? 'Provider Operations User' :
              value === 'telcoOperationUser' ? 'Telco Operations User' :
                value === 'telcoBusinessUser' ? 'Telco Business User' :
                  value === 'genericOperationUser' ? 'Operations User' :
                    value === 'genericBusinessUser' ? 'Business User' :
                      value === 'ISPOperationUser' ? 'ISP Operations User' :
                        value === 'systemUser' ? 'System User' :
                          value === 'telcoAdmin' ? 'Telco Admin' :
                            value === 'operatorAdmin' ? 'Operator Admin' :
                              value === 'genericAdmin' ? 'Generic Admin' :
                                value === 'partnerAdmin' ? 'Partner Admin' :
                                  value === 'ISPOperatorAdmin' ? 'ISP Operator Admin' :
                                    value === 'ISPPartnerAdmin' ? 'ISP Partner Admin' :
                                      value === 'smartMeterAdmin' ? 'Smart Meter Admin' :
                                        value === 'SGCAdmin' ? 'SGC Admin' :
                                          value === 'SGCExecutiveUser' ? 'SGC Executive User' :
                                            value === 'SGCOperationsUser' ? 'SGC Operations User' : 
                                              value === 'SGCPowerUser' ? 'SGC Power User' :
                                                'ISP Business User';
    }

    return {
      userId: item.userDetails?.userId || '-',
      userName: item.userDetails?.userName || '-',
      fullName: `${item.profile?.firstName || ''} ${item.profile?.lastName || ''}`,
      role: domainValue || '-',
      email: item.email || '-',
      phone: item.userDetails?.dialCode || item.userDetails?.phone ?
        `${item.userDetails?.dialCode} ${item.userDetails?.phone}` : '-',
      status: item.status,
    };
  });
}